import React from 'react';
import { FormInstance } from 'antd';
import {
  Input,
  InputNumber,
  Modal,
} from 'UI';

import {
  FormContainer,
  BaseFormItem,
  InlineButton,
} from './style';

export interface GerminationRoomFormData {
  name: string
  capacity: number
}

interface GerminationRoomModalProps {
  formHandler: FormInstance
  onSubmit(data: unknown): void
  onCancel(): void
  curRoom?: GerminationRoomFormData
  isLoading: boolean
  isVisible: boolean
}

const GerminationRoomModal = ({
  formHandler,
  onSubmit,
  onCancel,
  curRoom,
  isLoading,
  isVisible,
}: GerminationRoomModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={curRoom ? 'Editar câmara de germinação' : 'Nova câmara de germinação'}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Cancelar
      </InlineButton>,
      <InlineButton
        key="submit"
        onClick={onSubmit}
        disabled={isLoading}
        loading={isLoading}
      >
        Salvar câmara
      </InlineButton>,
    ]}
  >
    <FormContainer
      layout="vertical"
      form={formHandler}
      requiredMark={false}
      onFinish={onSubmit as (val: unknown) => void}
    >
      <BaseFormItem
        label="Nome"
        name="name"
        rules={[
          {
            required: true,
            message: 'Insira um nome',
          },
        ]}
        initialValue={curRoom?.name}
      >
        <Input disabled={isLoading} />
      </BaseFormItem>
      <BaseFormItem
        label="Capacidade"
        name="capacity"
        rules={[
          {
            required: true,
            message: 'Insira uma capacidade',
          },
        ]}
        initialValue={curRoom?.capacity}
      >
        <InputNumber min={0} disabled={isLoading} />
      </BaseFormItem>
    </FormContainer>
  </Modal>
);

GerminationRoomModal.defaultProps = {
  curRoom: undefined,
};

export default GerminationRoomModal;
